import { Component, ElementRef,  OnInit,  Input,  ViewChild, SimpleChange } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';

// import 'chartjs-adapter-moment';
import { Chart, registerables } from 'chart.js'
import 'chartjs-adapter-moment';

import * as moment from 'moment';
import { DatePipe } from '@angular/common';

import { DataGrafica } from 'src/app/models/data-grafica';
import { DataToGraf } from 'src/app/models/data-graf';
import { DataGraficaInactividad } from 'src/app/models/data-grafica-inactividad';
import { DataToGrafInactividad } from 'src/app/models/data-graf-inactividad';
import { DataGraficaHistorico } from 'src/app/models/data-graf-historico';
import { input } from 'aws-amplify';
import { DataGraficaInactividadHistorico } from 'src/app/models/data-grafica-inactividad-historico';
// import { DataPorcentOcupacion } from 'src/app/models/data-porcent-ocupacion';
const datePipe = new DatePipe('en-US');

const data = {
    labels: [''],
    datasets: [
      {
        label: ' ',
        data: [ ],
        backgroundColor: '',
        borderColor: '',
        fill: true,
        lineTension: 0.4,
        radius: 3,
        stepped: true,
      }
    ]
  };
  
  const dataHistorico = {
    labels: [''],
    datasets: [
      {
        label: ' ',
        data: [ 0 ],
        backgroundColor: '',
        borderColor: '',
        fill: true,
        lineTension: 0.4,
        radius: 3,
        stepped: true,
      },
      {
        label: '',
        data: [ 0 ],
        backgroundColor: '',
        borderColor: '',
        fill: true,
        lineTension: 0.4,
        radius: 3,
        stepped: true,
      }
    ]
  };

  const optionsLine = {
    responsive: true,
    maintainAspectRatio: true,
    title: {
      display: true,
      position: 'top',
      text: ' ',
      fontSize: 12,
      fontColor: '#666',
    },
    plugins: {
      title: {
        display: true,
        text: ''
      }
    },
    // legend: {
    //   display: true,
    //   position: 'bottom',
    //   labels: {
    //     fontColor: '#999',
    //     fontSize: 14,
    //   },
    // },
    scales: {
      x:  {     
        ticks: {
          // source: 'data',
          autoSkip: false,
          major: {
            enabled: true
          },
        },
        type: 'time',  
        time:{
           unit: 'hour',
           unitStepSize: 1,
           displayFormats: {
              'hour': 'HH:mm'
           }
        }
      },
      y:{
        ticks: {
          callback: function(value, index, ticks) {
            if (value == 1){
              return "OCUPADO";
            }else if (value == 0){
              return "LIBRE";
            }
        }
        },
          display: true,
          title: {
              display: true,
              text: ""
          }
      },
    }
  };

  const optionsBar = {
    responsive: true,
    maintainAspectRatio: true,
    title: {
      display: true,
      position: 'top',
      text: ' ',
      fontSize: 12,
      fontColor: '#666',
    },
    plugins: {
      title: {
        display: true,
        text: ''
      }
    },
    // legend: {
    //   display: true,
    //   position: 'bottom',
    //   labels: {
    //     fontColor: '#999',
    //     fontSize: 14,
    //   },
    // },
    scales: {
      x:  {     
        // ticks: {
        //   // source: 'data',
        //   autoSkip: false,
        //   major: {
        //     enabled: true
        //   },
        // },
        // type: 'time',  
        // time:{
        //    unit: 'hour',
        //    unitStepSize: 1,
        //    displayFormats: {
        //       'hour': 'HH:mm'
        //    }
        // }
      },
      y:{
        ticks: {
          unitStepSize: 1
        },
          display: true,
          title: {
              display: true,
              text: ""
          }
      },
    }
  };


//Opciones radiobutton
const ocup: string = "OCUPACIÓN";
const porocup: string = "% OCUPACIÓN";
const mov: string  = "% MOVIMIENTO EN ESTANCIA";
const inac:  string = "% INACTIVIDAD EN REPOSO";
const nocup: string = "Nº CAMBIOS EN OCUPACIÓN";

const usofridge: string = "USO";
const movcocina: string = "% MOVIMIENTO EN LA COCINA";


const horaTimestamp: number = 3600000;

@Component({
  selector: 'app-grafica-bar',
  templateUrl: './grafica-bar.component.html',
  styleUrls: ['./grafica-bar.component.scss']
})
export class GraficaBarComponent implements OnInit {

DEBUG: boolean = false;


  constructor(private elementRef: ElementRef, private _cdref:ChangeDetectorRef) {
    Chart.register(...registerables);
  }

  //cargamos la opcion seleccionada por el radiobutton

  @Input() dataGrafica: DataGrafica;
  @Input() dataGraficaInactividad: DataGraficaInactividad;
  @Input() dataGraficaHistorico: DataGraficaHistorico;
  @Input() dataGraficaInactividadHistorico: DataGraficaInactividadHistorico;
  @Input() flagCargaGrafica: boolean;
  dataToGrafInactividad: DataToGrafInactividad;
  dataToGraf: DataToGraf;

  // dataPorcentOcupacion: DataPorcentOcupacion;

// Input para la fecha EJEX

  name = 'ChartJs';
  chart: any;
  ctx: any = document.getElementById('barChart') as HTMLElement;
  // flagCargaGrafica: boolean = true;
  flagGraficaHistorico: boolean = false;
  typeChart: any;

  @ViewChild('barChart', { static: false }) private chartRef: ElementRef;


  timeIni: number;
  timeFin: number;
  timeHistIni: number;
  timeHistFin: number;

  tipoGrafica: string;
  data: number[] = [];
  dataHistorico: number[] = [];
  numDia: number; // número de dias a comprarar
  dataOcupacionLineal:string [] = [];
  labelsGrafica: any[] = [];
  labels: any[] = [];
  labelsHistorico: any[] = [];
  porcentajeOcupacion: string[]=[];

  flagViewGraf: boolean = false;

  ngOnInit(){
    if(this.DEBUG){
      console.log('[Grafica BAR] ngOnInit');
    }
    this.flagCargaGrafica = true;
    this.ctx = document.getElementById('barChart') as HTMLElement;
    // this._cdref.detectChanges();

    // this.createChart();
  }

  ngAfterViewInit() {
    this.ctx = document.getElementById('barChart') as HTMLElement;
    if(this.DEBUG){
      console.log('[Grafica BAR] ngAfterViewInit');
    }
    
    // this._cdref.detectChanges();

    // this.createChart();

    
  }

  ngOnChanges(changes: SimpleChange): void {
    this.flagCargaGrafica = false;
    // this.ctx = document.getElementById('barChart') as HTMLElement;
    if(this.DEBUG){
      console.log("ngOnChanges");
      console.log("FLAG CARGAR GRAFICA: " + this.flagCargaGrafica);
    }
    if(this.dataGrafica != undefined && this.dataGraficaInactividad != undefined){
    //Obtenemos los datos pasados a la gráfica    
    if(this.dataGraficaHistorico != null || this.dataGraficaInactividadHistorico != null){
      this.flagGraficaHistorico = true;
    }else{
      this.flagGraficaHistorico = false;
      // this.flagCargaGrafica = false;
      // console.log("FLAG CARGAR GRAFICA: " + this.flagCargaGrafica);
    }

    if(this.dataGrafica.tipoGrafica != ""){ 
      if(this.DEBUG){
        console.log('[Grafica BAR]: ' + this.dataGrafica.tipoGrafica);
        console.log("dataGrafica: ");
        console.log(this.dataGrafica)
        console.log("dataGraficaHistorico: ");
        console.log(this.dataGraficaHistorico)
      }
      this.timeIni = this.dataGrafica.timeIni; 
      this.timeFin = this.dataGrafica.timeFin;
      this.tipoGrafica = this.dataGrafica.tipoGrafica;
  
      // Modificamos las opciones de los ejes de la grafica dependiendo de los datos recibidos
      this.confDataGrafica();

    }else if(this.dataGraficaInactividad.tipoGrafica != ""){
      if(this.DEBUG){
        console.log('[Grafica BAR]: ' + this.dataGraficaInactividad.tipoGrafica);
      }
      this.timeIni = this.dataGraficaInactividad.timeIni; 
      this.timeFin = this.dataGraficaInactividad.timeFin;
      this.tipoGrafica = this.dataGraficaInactividad.tipoGrafica;
      this.confDataGrafica();
    }
  }else{

    // this.flagCargaGrafica = true;
  }
        
  }

  confDataGrafica(){

    this.flagCargaGrafica = false;
    this.ctx = document.getElementById('barChart') as HTMLElement;

    switch(this.tipoGrafica) { 
      case ocup: { 
        //OCUPACIÓN
          this.ocupacion();
         break; 
      } 
      case porocup: { 
        //% OCUPACIÓN
          this.porOcupacion();
         break; 
      } 
      case mov: { 
         // % MOVIMIENTO EN ESTANCIA (SIN OCUPACION)
         this.porMovimiento();
         break; 
      } 
      case inac: { 
        // % INACTIVIDAD EN REPOSO (CON OCUPACION)
        // console.log(this.timeIni);
        // this.timeIni = new Date().getTime();
        // console.log(this.timeIni +" " + new Date().getTime());
        // console.log(new Date().getTime()-this.timeFin);

        this.porInactividad();
        break; 
      } 
      case nocup: { 
        // Nº CAMBIOS EN OCUPACIÓN; 
        this.numCambiosOcupa();
        break; 
      } 
      case usofridge: { 
        // USO DEL FRIGORIFICO
        this.usoFridge();
        break; 
      } 
      case movcocina: { 
        // % USO DEL FRIGORIFICO
        this.porMovimientoCocina();
        break; 
      } 

      default: { 
         //statements; 
         break; 
      } 
    }
  }


  public configGrafica(){
    //cargamos la opcion seleccionada por el radiobutton
    // Seleccionamos la gráfica que queremos con las opciones personalizadas de cada una
    switch(this.tipoGrafica) {  
      case ocup: { 
        // OCUPACIÓN SELECCIONADA
        this.typeChart = "line";
        data.datasets[0].stepped = true;
        data.datasets[0].data = this.data; //Datos eje Y
        data.labels = this.labels; //Datos eje X
        data.datasets[0].backgroundColor = '#3E95CD';
        data.datasets[0].fill = true;
        data.datasets[0].borderColor = '#3E95CD';
        // optionsLine.title.text = this.tipoGrafica;
        // data.datasets[0].label = this.tipoGrafica;
        optionsLine.plugins.title.text = this.tipoGrafica;
        // baseConfig2.options.scales.yAxes[0].labels = ['OCUPADO', 'LIBRE'];
        // options.legend.scales.y[0].ticks.stepSize = 1;

        this.flagViewGraf = true;

        // creamos la gráfica
        // this.flagCargaGrafica = true;
        // this.chart = new Chart(this.chartRef.nativeElement, baseConfig2);        
        this.createChartLine();
         break; 
      } 
      case porocup: { 

        if(this.flagGraficaHistorico){
          // % OCUPACIÓN HISTORICA
          console.log("% OCUPACIÓN HISTORICA")
          
          let labelMedia_string = "Media de los últimos " + this.numDia + " días";

          this.typeChart = "bar";
          optionsBar.scales.y.title.text  = "%";  
          dataHistorico.datasets[0].data = this.data; //Datos eje Y 
          dataHistorico.datasets[1].data = this.dataHistorico; //Datos eje Y
          dataHistorico.datasets[0].label = "Día selecionado";
          dataHistorico.datasets[1].label = labelMedia_string;
          dataHistorico.labels = this.labelsGrafica; //Datos eje X
          dataHistorico.datasets[0].backgroundColor = '#3E95CD';
          dataHistorico.datasets[1].backgroundColor = '#EF4B3F';
          dataHistorico.datasets[0].borderColor = '#1E88E5';
          dataHistorico.datasets[1].borderColor = '#BF4B3F';          

          optionsBar.plugins.title.text = this.tipoGrafica;

        }else{
        // % OCUPACIÓN 
          console.log("% OCUPACIÓN")
          this.typeChart = "bar";
          optionsBar.scales.y.title.text  = "%";  
          data.datasets[0].data = this.data; //Datos eje Y 
          data.datasets[0].label = " ";
          data.labels = this.labelsGrafica; //Datos eje X
          data.datasets[0].backgroundColor = '#3E95CD';
          data.datasets[0].borderColor = '#1E88E5';

          optionsBar.plugins.title.text = this.tipoGrafica;
        }

        this.flagViewGraf = true;
        
        // creamos la gráfica

        this.createChartBar();
         break; 
      } 
      case mov: { 

         if(this.flagGraficaHistorico){
          // % MOVIMIENTO EN ESTANCIA 
          console.log("% MOVIMIENTO EN ESTANCIA HISTORICA")
  
          this.typeChart = "bar";
          optionsBar.scales.y.title.text  = "%";  
          dataHistorico.datasets[0].data = this.data; //Datos eje Y 
          dataHistorico.datasets[1].data = this.dataHistorico; //Datos eje Y
          dataHistorico.datasets[0].label = "Día selecionado";
          dataHistorico.datasets[1].label = "Media";
          dataHistorico.labels = this.labelsGrafica; //Datos eje X
          dataHistorico.datasets[0].backgroundColor = '#3E95CD';
          dataHistorico.datasets[1].backgroundColor = '#EF4B3F';
          dataHistorico.datasets[0].borderColor = '#1E88E5';
          dataHistorico.datasets[1].borderColor = '#BF4B3F';          
  
          optionsBar.plugins.title.text = this.tipoGrafica;
  
        }else{
          // % MOVIMIENTO EN ESTANCIA  
          console.log("% MOVIMIENTO EN ESTANCIA ")
  
           this.typeChart = "bar";
           optionsBar.scales.y.title.text  = "%";  
           data.datasets[0].data = this.data; //Datos eje Y 
           // data.datasets[0].label = "1";
           data.labels = this.labelsGrafica; //Datos eje X
           data.datasets[0].backgroundColor = '#3E95CD';
           data.datasets[0].borderColor = '#1E88E5';
           // optionsBar.title.text = this.tipoGrafica;
           // data.datasets[0].label = this.tipoGrafica;
           optionsBar.plugins.title.text = this.tipoGrafica;
        }

         this.flagViewGraf = true;

        // creamos la gráfica
        // this.flagCargaGrafica = true;

        this.createChartBar();
         break; 
      } 
      case inac: { 
        // % INACTIVIDAD EN REPOSO (CON OCUPACION)
        console.log("% INACTIVIDAD EN REPOSO")

        this.typeChart = "bar";
        optionsBar.scales.y.title.text  = "%";
        data.datasets[0].data = this.data;//Datos eje Y
        data.labels = this.labels; //Datos eje X
        data.datasets[0].backgroundColor = '#3E95CD'; //2A
        data.datasets[0].borderColor = '#FDD835';

        optionsBar.plugins.title.text = this.tipoGrafica;

        this.flagViewGraf = true;

        // creamos la gráfica
        // this.flagCargaGrafica = true;
        this.createChartBar();
        break; 
      } 
      case nocup: { 
        // Nº CAMBIOS EN OCUPACIÓN; 
        this.typeChart = "bar";

        data.datasets[0].data = this.data;//Datos eje Y
        data.labels = this.labels; //Datos eje X
        data.datasets[0].backgroundColor = '#3E95CD';
        data.datasets[0].borderColor = '#FDD835';

        optionsBar.plugins.title.text = this.tipoGrafica;

        this.flagViewGraf = true;

        // creamos la gráfica
        this.createChartBar();
        break; 
      } 
      case usofridge: {   
        
        if(this.flagGraficaHistorico){
          // USO FRIGORIFICO HISTORICA
          console.log("USO FRIGORIFICO HISTORICA")

          this.typeChart = "bar";
          dataHistorico.datasets[0].data = this.data; //Datos eje Y 
          dataHistorico.datasets[1].data = this.dataHistorico; //Datos eje Y
          dataHistorico.datasets[0].label = "Día selecionado";
          dataHistorico.datasets[1].label = "Media";
          dataHistorico.labels = this.labelsGrafica; //Datos eje X
          dataHistorico.datasets[0].backgroundColor = '#3E95CD';
          dataHistorico.datasets[1].backgroundColor = '#EF4B3F';
          dataHistorico.datasets[0].borderColor = '#1E88E5';
          dataHistorico.datasets[1].borderColor = '#BF4B3F';          

          optionsBar.plugins.title.text = this.tipoGrafica;

        }else{
        // USO DEL FRIGORIFICO 
        console.log("USO FRIGORIFICO")

          this.typeChart = "bar";
          data.datasets[0].data = this.data; //Datos eje Y 
          data.labels = this.labelsGrafica; //Datos eje X
          data.datasets[0].backgroundColor = '#3E95CD';
          data.datasets[0].borderColor = '#1E88E5';

          optionsBar.plugins.title.text = this.tipoGrafica;
        }        

        this.flagViewGraf = true;

        // creamos la gráfica
        this.createChartBar();
        break; 
      } 
      case movcocina: { 
        
      if(this.flagGraficaHistorico){
        // % MOVIMIENTO EN ESTANCIA 
        console.log("% MOVIMIENTO EN ESTANCIA HISTORICA")

        this.typeChart = "bar";
        optionsBar.scales.y.title.text  = "%";  
        dataHistorico.datasets[0].data = this.data; //Datos eje Y 
        dataHistorico.datasets[1].data = this.dataHistorico; //Datos eje Y
        dataHistorico.datasets[0].label = "Día selecionado";
        dataHistorico.datasets[1].label = "Media";
        dataHistorico.labels = this.labelsGrafica; //Datos eje X
        dataHistorico.datasets[0].backgroundColor = '#3E95CD';
        dataHistorico.datasets[1].backgroundColor = '#EF4B3F';
        dataHistorico.datasets[0].borderColor = '#1E88E5';
        dataHistorico.datasets[1].borderColor = '#BF4B3F';          

        optionsBar.plugins.title.text = this.tipoGrafica;

      }else{
        // % MOVIMIENTO EN ESTANCIA  
        console.log("% MOVIMIENTO EN ESTANCIA ")

         this.typeChart = "bar";
         optionsBar.scales.y.title.text  = "%";  
         data.datasets[0].data = this.data; //Datos eje Y 
         // data.datasets[0].label = "1";
         data.labels = this.labelsGrafica; //Datos eje X
         data.datasets[0].backgroundColor = '#3E95CD';
         data.datasets[0].borderColor = '#1E88E5';
         // optionsBar.title.text = this.tipoGrafica;
         // data.datasets[0].label = this.tipoGrafica;
         optionsBar.plugins.title.text = this.tipoGrafica;
      }         

        this.flagViewGraf = true;

       // creamos la gráfica
      //  this.flagCargaGrafica = true;
       this.createChartBar();

        break; 
     }
      default: { 
         //statements; 
         break; 
      } 
   }

   
   
  }

  createChartLine(){
    // this.flagViewGraf = true;
    this.flagCargaGrafica = true;
    // console.log("FLAG CARGAR GRAFICA: " + this.flagCargaGrafica);

    this.ctx = document.getElementById('barChart') as HTMLElement;

    if(this.flagGraficaHistorico){
      this.chart = new Chart(this.ctx, {
        type: this.typeChart,
        data: dataHistorico,
        options: optionsLine,
      });

    }else{
      this.chart = new Chart(this.ctx, {
        type: this.typeChart,
        data: data,
        options: optionsLine,
      });
    }


  }

  createChartBar(){
    // this.flagViewGraf = true;
    this.flagCargaGrafica = true;
    // console.log("FLAG CARGAR GRAFICA: " + this.flagCargaGrafica);

    this.ctx = document.getElementById('barChart') as HTMLElement;

    if(this.flagGraficaHistorico){
      this.chart = new Chart(this.ctx, {
        type: this.typeChart,
        data: dataHistorico,
        options: optionsBar,
      });

    }else{
      this.chart = new Chart(this.ctx, {
        type: this.typeChart,
        data: data,
        options: optionsBar,
      });
    }


  }

  // createChart(){
  //   // this.flagViewGraf = true;
  //   this.chart = new Chart(this.chartRef.nativeElement, baseConfig);
  // }


// ------------------------------------------ OCUPACIÓN ------------------------------------------------------
  ocupacion(){

  // Calculamos la ocupación durante el día de hora a hora
  //Limpiamos los valores
  this.data = [];
  this.labels = [];

  let horaIni;
  let horaFin;
  
  horaIni = datePipe.transform(this.dataGrafica.data.timestamp[0], 'HH:mm dd/MM/YYY');
  horaFin = datePipe.transform(this.dataGrafica.data.timestamp[this.dataGrafica.data.timestamp.length-1], 'HH:mm dd/MM/YYY');
  console.log("horaIni: " + horaIni);
  console.log("horaFin: " + horaFin);


  // console.log(this.dataGrafica.data);
  this.asyncMethodConvertTimeOcupacion(); // cambiamos el timestamp a fecha humana
  }
    async asyncMethodConvertTimeOcupacion() {
  let timestampAux: number [] = [];
  let dataAux: string[] = [];
  let dataAux2: number[] = [];
  let labelsAux: any[] = [];
  let labelsAuxTimestamp: any[] = [];
  
  //primero  eliminamos los que tengan un cambio inferior a 30 min.(30000 ms) 

  // Primer dato
  if(this.dataGrafica.data.data[0] == 1){
    dataAux.push("OCUPADO");
    dataAux2.push(this.dataGrafica.data.data[0]);
  }else{
    dataAux.push("LIBRE");
    dataAux2.push(this.dataGrafica.data.data[0]);
  }

  timestampAux.push(this.dataGrafica.data.timestamp[0]);

  for (let i = 1; i < this.dataGrafica.data.data.length ; i++) {//-1; i++) {
    if(this.dataGrafica.data.data[i] != undefined){
      // s if((this.dataGrafica.data.timestamp[i] - this.dataGrafica.data.timestamp[i-1]) > 30000){
        if(this.dataGrafica.data.data[i] == 1){
          dataAux.push("OCUPADO");
          dataAux2.push(this.dataGrafica.data.data[i]);
        }else{
          dataAux.push("LIBRE");
          dataAux2.push(this.dataGrafica.data.data[i]);  
        }
        
        timestampAux.push(this.dataGrafica.data.timestamp[i]);
      // }
    }
  }

  for (let i = 0; i < timestampAux.length; i++) {
    if(timestampAux[i] != undefined){
    //   labelsAux.push(moment(timestampAux[i]).format("HH:mm:DD:MM:YYYY"));
        labelsAux.push(moment(timestampAux[i]).format("HH:mm DD-MM")); 
      labelsAuxTimestamp.push(timestampAux[i]);
    }
  }

if(this.DEBUG){    
  console.log("NEW DATA: ");
  console.log(dataAux);
  console.log("NEW TIMESTAMP: ");
  console.log(timestampAux);
  console.log("NEW labels: ");
  console.log(labelsAux);
}



  let timeAux: number;
  let labelTimestamp: number[] = [];

  // Hacemos el eje X correspondiente a las horas
  labelTimestamp[0] = this.timeIni;
  timeAux = this.timeIni;

  // console.log("TimeIni: " + this.timeIni);
  // console.log("TimeFin: " + this.timeFin);
  // console.log("TIMEAUX:" + timeAux);

  while (timeAux < this.timeFin){
    labelTimestamp.push(timeAux + horaTimestamp);
    timeAux = timeAux + horaTimestamp;
  }


  //limpiamos data donde meteremos el %
  this.dataOcupacionLineal = [];
  this.data = []
  this.labels = [];

  let tiempoaux: any = 0;
  for (let i = 0; i < labelTimestamp.length; i++) {
  if(labelTimestamp[i] != undefined){
    //console.log(moment(this.dataGrafica.data.timestamp[i]).format("HH:mm"));
    tiempoaux = moment(labelTimestamp[i]).format("HH:00");
    if (tiempoaux == "00:00"){
      this.labels.push(moment(labelTimestamp[i]).format("DD/MM/YYYY"));
    }else{
      this.labels.push(moment(labelTimestamp[i]).format("HH:00"));
    }
  }
  }




  this.dataOcupacionLineal = dataAux;
  this.data = dataAux2;
  // this.labels = labelsAux;
  this.labels = labelsAuxTimestamp; // Modificacion chartjs 3.7.0



  if (this.chart){
    this.chart.clear();
    this.chart.destroy();
  }
  this.configGrafica();
  }

// ------------------------------------------ PORCENTAJE DE OCUPACIÓN ------------------------------------------------------
  porOcupacion(){
    // Calculamos el porcentaje de movimiento durante el día de hora a hora
    //Limpiamos los valores
    this.data = [];
    this.dataHistorico = [];
    this.labels = [];
    this.labelsHistorico = [];
    this.labelsGrafica = [];

    this.asyncMethodConvertTimePorOcupacion(this.dataGrafica, false); // cambiamos el timestamp a fecha humana
    
    if(this.flagGraficaHistorico){
      this.asyncMethodConvertTimePorOcupacion(this.dataGraficaHistorico, true);
    }

  }

  async asyncMethodConvertTimePorOcupacion(dataGraficaLocal, flagHistorico: boolean) {
    this.timeIni = dataGraficaLocal.timeIni;
    this.timeFin = dataGraficaLocal.timeFin;
    
    let timestampAux: number [] = [];
    let dataAux: number[] = [];
    let labelsAux: any[] = []
    
    //primero  eliminamos los que tengan un cambio inferior a 5 min.(300000 ms) 

    dataAux.push(dataGraficaLocal.data.data[0]);
    timestampAux.push(dataGraficaLocal.data.timestamp[0]);

    for (let i = 1; i < dataGraficaLocal.data.data.length -1; i++) {
      if(dataGraficaLocal.data.data[i] != undefined){
        if((dataGraficaLocal.data.timestamp[i] - dataGraficaLocal.data.timestamp[i-1]) > 300000){
          dataAux.push(dataGraficaLocal.data.data[i]);
          timestampAux.push(dataGraficaLocal.data.timestamp[i]);
        }
      }
    }

    for (let i = 0; i < timestampAux.length; i++) {
      if(timestampAux[i] != undefined){
        labelsAux.push(moment(timestampAux[i]).format("HH:mm:DD:MM:YYYY"));
      }
    }

  // if(this.DEBUG){    
  //   console.log("NEW DATA: ");
  //   console.log(dataAux);
  //   console.log("NEW TIMESTAMP: ");
  //   console.log(timestampAux);
  //   console.log("NEW labels: ");
  //   console.log(labelsAux); 
  // }


    let timeAux: number;
    let labelTimestamp: number[] = [];

    // Hacemos el eje X correspondiente a las horas
    labelTimestamp[0] = this.timeIni;
    timeAux = this.timeIni;


    while (timeAux < this.timeFin){
      labelTimestamp.push(timeAux + horaTimestamp);
      timeAux = timeAux + horaTimestamp;
    }

    if(!flagHistorico){
      console.log("1 DIA");
      // Guardamos el eje X que es el de 1 día
      this.labels = [];
      for (let i = 0; i < labelTimestamp.length-1; i++) {
        if(labelTimestamp[i] != undefined){
            this.labelsGrafica.push(moment(labelTimestamp[i]).format("HH:00:DD:MM:YYYY"));
            this.labels.push(moment(labelTimestamp[i]).format("HH:00:DD:MM:YYYY"));
        }
      }
      console.log("LABELS GRAFICA:");
      console.log(this.labelsGrafica);
    }else{
      console.log("HISTORICO");
      console.log(dataGraficaLocal)
      this.labels = [];
      for (let i = 0; i < labelTimestamp.length-1; i++) {
        if(labelTimestamp[i] != undefined){
            this.labels.push(moment(labelTimestamp[i]).format("HH:00:DD:MM:YYYY"));
        }
      }
      console.log("LABELS HISTORICO:");
      console.log(this.labels);
    }

    // console.log(this.labels);

    //limpiamos data o dataHistorico donde meteremos el %
    if(flagHistorico){
      this.dataHistorico = [];
    }else{
      this.data = [];
    }

    // console.log(dataAux[0]);

    let auxOcup = 0;;
    let auxLib = 0;

    for(let i=0; i < this.labels.length; i++){ //for(let i=1; i < this.labels.length-1; i++){

      for(let j=1;j < labelsAux.length-1; j++){

        if ((this.labels[i].split(":")[0] == labelsAux[j].split(":")[0]) && (this.labels[i].split(":")[2] == labelsAux[j].split(":")[2]) ){
          // Estamos en la misma hora y guardamos los min que esta ocupado de 1 a 0
          //Miramos si j=0
          if(j==0){
              if(dataAux[j] == 0){
                //libre
                auxLib = auxLib + (60 - Number(labelsAux[j].split(":")[1]));
              }else if (dataAux[j] == 1){
                //libre
                auxOcup = auxOcup + (60 - Number(labelsAux[j].split(":")[1]));
                this.data[i] = auxOcup;
              }
          }else{

             // Misma hora
            if(labelsAux[j-1].split(":")[0] == labelsAux[j].split(":")[0]){
              if (dataAux[j-1] == 0 && dataAux[j] == 0){
                //LIBRE
                auxLib = auxLib + (Number(labelsAux[j].split(":")[1]) - Number(labelsAux[j-1].split(":")[1]));
              }else if (dataAux[j-1] == 0 && dataAux[j] == 1){
                //LIBRE
                auxLib = auxLib + (Number(labelsAux[j].split(":")[1]) - Number(labelsAux[j-1].split(":")[1]));
              }else if (dataAux[j-1] == 1 && dataAux[j] == 1){
                //OCUPADO
                auxOcup = auxOcup + (Number(labelsAux[j].split(":")[1]) - Number(labelsAux[j-1].split(":")[1]));
              }else if (dataAux[j-1] == 1 && dataAux[j] == 0){
                //OCUPADO
                auxOcup = auxOcup + (Number(labelsAux[j].split(":")[1]) - Number(labelsAux[j-1].split(":")[1]));
              }
            }
            if((Number(labelsAux[j].split(":")[0]) < Number(labelsAux[j+1].split(":")[0])) && (Number(labelsAux[j].split(":")[2]) == Number(labelsAux[j+1].split(":")[2]))){ 
              // último dato de la hora del mismo día
                  if(dataAux[j] == 0){
                    //libre
                    auxLib = auxLib + (60 - Number(labelsAux[j].split(":")[1]));
                  }else if (dataAux[j] == 1){
                    //libre
                    auxOcup = auxOcup + (60 - Number(labelsAux[j].split(":")[1]));
                  
                  }
    
              }else if((Number(labelsAux[j].split(":")[0]) > Number(labelsAux[j+1].split(":")[0])) && (Number(labelsAux[j].split(":")[2]) < Number(labelsAux[j+1].split(":")[2]))){ 
              // último dato de la hora de finales del día 
                if(dataAux[j] == 0){
                  //libre
                  auxLib = auxLib + (60 - Number(labelsAux[j].split(":")[1]));
                }else if (dataAux[j] == 1){
                  //libre
                  auxOcup = auxOcup + (60 - Number(labelsAux[j].split(":")[1]));
                
                }
              }
            // primer dato de la hora
            if ((Number(labelsAux[j-1].split(":")[0]) < Number(labelsAux[j].split(":")[0]))){ 
              if (dataAux[j-1] == 0 && dataAux[j] == 0){
                //LIBRE
                auxLib = auxLib + Number(labelsAux[j].split(":")[1]);
              }else if (dataAux[j-1] == 0 && dataAux[j] == 1){
                //LIBRE
                auxLib = auxLib + Number(labelsAux[j].split(":")[1]);

              }else if (dataAux[j-1] == 1 && dataAux[j] == 1){
                //OCUPADO
                auxOcup = auxOcup + Number(labelsAux[j].split(":")[1]);

              }else if (dataAux[j-1] == 1 && dataAux[j] == 0){
                //OCUPADO
                auxOcup = auxOcup + Number(labelsAux[j].split(":")[1]);

              }
            }
          }
        }
      }

      if(this.DEBUG){  
        // console.log(i + " - "+ this.labels[i] + " - LIBRE: " +auxLib +" m - OCUPADO: " + auxOcup );
      }
      // Pasamos los datos a %
      auxOcup = (auxOcup * 100)/60

      if(flagHistorico){
        this.dataHistorico[i] = Math.round(auxOcup);
        console.log(i + " - "+ this.labels[i] + " EN MOVIMIENTO : " + auxOcup + "%");
      }else{
        this.data[i] = Math.round(auxOcup);
        console.log(i + " - "+ this.labels[i] + " EN MOVIMIENTO : " + auxOcup + "%");
      }  


      //inicializamos
      auxOcup = 0;
      auxLib = 0;
    }

    // console.log("% OCUPACION");
    // console.log(this.data);

    if(flagHistorico){
      this.numDia = this.dataHistorico.length/24;
  
      let dataHistoricoAux = [];
      dataHistoricoAux = this.dataHistorico;
      this.dataHistorico = [];
  
      for(let i=0; i < 24; i++){
        this.dataHistorico [i] = dataHistoricoAux[i]
        for(let j=1; j < this.numDia; j++){ // El primer día ya lo hemos metido
          this.dataHistorico[i] = this.dataHistorico[i] + dataHistoricoAux[24*j+i]
        }
        this.dataHistorico[i] =  Math.round(this.dataHistorico[i]/this.numDia);
      }
    }
   
    if(!flagHistorico){
      let tiempoaux: any = 0;
      this.labelsGrafica = [];
      for (let i = 0; i < labelTimestamp.length; i++) {
      if(labelTimestamp[i] != undefined){
        //console.log(moment(this.dataGrafica.data.timestamp[i]).format("HH:mm"));
        tiempoaux = moment(labelTimestamp[i]).format("HH:00");
        if (tiempoaux == "00:00"){
          this.labelsGrafica.push(moment(labelTimestamp[i]).format("DD/MM/YYYY"));
        }else{
          this.labelsGrafica.push(moment(labelTimestamp[i]).format("HH:00"));
        }
      }
      }
    } 

    if (this.chart){
      this.chart.clear();
      this.chart.destroy();
    }
    this.configGrafica();
  }

// ------------------------------------------ PORCENTAJE DE MOVIMIENTO EN ESTANCIA -----------------------------------------
  porMovimiento(){
    // Calculamos el porcentaje de movimiento durante el día de hora a hora
    //Limpiamos los valores
    this.data = [];
    this.dataHistorico = [];
    this.labels = [];
    this.labelsHistorico = [];
    this.labelsGrafica = [];

    this.asyncMethodConvertTimePorMovimiento(this.dataGrafica, false);
    if(this.flagGraficaHistorico){
      this.asyncMethodConvertTimePorMovimiento(this.dataGraficaHistorico, true);
    }

  }

  async asyncMethodConvertTimePorMovimiento(dataGraficaLocal, flagHistorico: boolean) {
    this.timeIni = dataGraficaLocal.timeIni;
    this.timeFin = dataGraficaLocal.timeFin;
    
    let timestampAux: number [] = [];
    let dataAux: number[] = [];
    let labelsAux: any[] = []
    
    //primero  eliminamos los que tengan un cambio inferior a 1 min.(60000 ms) 

    dataAux.push(dataGraficaLocal.data.data[0]);
    timestampAux.push(dataGraficaLocal.data.timestamp[0]);

    for (let i = 1; i < dataGraficaLocal.data.data.length -1; i++) {
      if(dataGraficaLocal.data.data[i] != undefined){
        if((dataGraficaLocal.data.timestamp[i] - dataGraficaLocal.data.timestamp[i-1]) > 60000){
          dataAux.push(dataGraficaLocal.data.data[i]);
          timestampAux.push(dataGraficaLocal.data.timestamp[i]);
        }
      }
    }

    for (let i = 0; i < timestampAux.length; i++) {
      if(timestampAux[i] != undefined){
        labelsAux.push(moment(timestampAux[i]).format("HH:mm:DD:MM:YYYY"));
      }
    }


    // if(this.DEBUG){   
    //   console.log("NEW DATA: ");
    //   console.log(dataAux);
    //   console.log("NEW TIMESTAMP: ");
    //   console.log(timestampAux);
    //   console.log("NEW labels: ");
    //   console.log(labelsAux);
    // }

    let timeAux: number;
    let labelTimestamp: number[] = [];

    // Hacemos el eje X correspondiente a las horas
    labelTimestamp[0] = this.timeIni;
    timeAux = this.timeIni;

    while (timeAux < this.timeFin){
      labelTimestamp.push(timeAux + horaTimestamp);
      timeAux = timeAux + horaTimestamp;
    }

    if(!flagHistorico){
      console.log("1 DIA");
      // Guardamos el eje X que es el de 1 día
      this.labels = [];
      for (let i = 0; i < labelTimestamp.length-1; i++) {
        if(labelTimestamp[i] != undefined){
            this.labelsGrafica.push(moment(labelTimestamp[i]).format("HH:00:DD:MM:YYYY"));
            this.labels.push(moment(labelTimestamp[i]).format("HH:00:DD:MM:YYYY"));
        }
      }
      console.log("LABELS GRAFICA:");
      console.log(this.labelsGrafica);
    }else{
      console.log("HISTORICO");
      console.log(dataGraficaLocal)
      this.labels = [];
      for (let i = 0; i < labelTimestamp.length-1; i++) {
        if(labelTimestamp[i] != undefined){
            this.labels.push(moment(labelTimestamp[i]).format("HH:00:DD:MM:YYYY"));
        }
      }
      console.log("LABELS HISTORICO:");
      console.log(this.labels);
    }

    // console.log(this.labels);

    //limpiamos data o dataHistorico donde meteremos el %
    if(flagHistorico){
      this.dataHistorico = [];
    }else{
      this.data = [];
    }

    // console.log(dataAux[0]);

    let auxConMov= 0;;
    let auxSinMov = 0;

    for(let i=0; i < this.labels.length; i++){ //for(let i=1; i < this.labels.length-1; i++){

      for(let j=0;j < labelsAux.length-1; j++){

        if ((this.labels[i].split(":")[0] == labelsAux[j].split(":")[0]) && (this.labels[i].split(":")[2] == labelsAux[j].split(":")[2]) ){
          // Estamos en la misma hora y guardamos los min que esta en movimiento de 1 a 0
          //Miramos si j=0
          if(j==0){
              if(dataAux[j] == 0){
                // SINMovimiento
                auxSinMov = auxSinMov + (60 - Number(labelsAux[j].split(":")[1]));
              }else if (dataAux[j] == 1){
                // SINMovimiento
                auxConMov = auxConMov + (60 - Number(labelsAux[j].split(":")[1]));
                this.data[i] = auxConMov;
              }
          }else{

             // Misma hora
            if(labelsAux[j-1].split(":")[0] == labelsAux[j].split(":")[0]){
              if (dataAux[j-1] == 0 && dataAux[j] == 0){
                //SINMovimiento
                auxSinMov = auxSinMov + (Number(labelsAux[j].split(":")[1]) - Number(labelsAux[j-1].split(":")[1]));
              }else if (dataAux[j-1] == 0 && dataAux[j] == 1){
                //SINMovimiento
                auxSinMov = auxSinMov + (Number(labelsAux[j].split(":")[1]) - Number(labelsAux[j-1].split(":")[1]));
              }else if (dataAux[j-1] == 1 && dataAux[j] == 1){
                //CONMovimiento
                auxConMov = auxConMov + (Number(labelsAux[j].split(":")[1]) - Number(labelsAux[j-1].split(":")[1]));
              }else if (dataAux[j-1] == 1 && dataAux[j] == 0){
                //CONMovimiento
                auxConMov = auxConMov + (Number(labelsAux[j].split(":")[1]) - Number(labelsAux[j-1].split(":")[1]));
              }
            }
            // último dato de la hora
            if((Number(labelsAux[j].split(":")[0]) < Number(labelsAux[j+1].split(":")[0]))){ 

                if(dataAux[j] == 0){
                  //SINMovimiento
                  auxSinMov = auxSinMov + (60 - Number(labelsAux[j].split(":")[1]));
                }else if (dataAux[j] == 1){
                  //CONMovimiento
                  auxConMov = auxConMov + (60 - Number(labelsAux[j].split(":")[1]));
                
                }

            }
            // primer dato de la hora
            if ((Number(labelsAux[j-1].split(":")[0]) < Number(labelsAux[j].split(":")[0]))){ 
              if (dataAux[j-1] == 0 && dataAux[j] == 0){
                //SINMovimiento
                auxSinMov = auxSinMov + Number(labelsAux[j].split(":")[1]);
              }else if (dataAux[j-1] == 0 && dataAux[j] == 1){
                //SINMovimiento
                auxSinMov = auxSinMov + Number(labelsAux[j].split(":")[1]);

              }else if (dataAux[j-1] == 1 && dataAux[j] == 1){
                //CONMovimiento
                auxConMov = auxConMov + Number(labelsAux[j].split(":")[1]);

              }else if (dataAux[j-1] == 1 && dataAux[j] == 0){
                //CONMovimiento
                auxConMov = auxConMov + Number(labelsAux[j].split(":")[1]);

              }
            }
          }
        }
      }

      if(this.DEBUG){  
        // console.log(i + " - "+ this.labels[i] + " - SIN MOVIMIENTO: " +auxSinMov +" m - EN MOVIMIENTO: " + auxConMov );
      }
      // Pasamos los datos a %
      auxConMov = (auxConMov * 100)/60

      if(flagHistorico){
        this.dataHistorico[i] = Math.round(auxConMov);
        console.log(i + " - "+ this.labels[i] + "EN MOVIMIENTO : " + auxConMov + "%");
      }else{
        this.data[i] = Math.round(auxConMov);
        console.log(i + " - "+ this.labels[i] + "EN MOVIMIENTO : " + auxConMov + "%");
      } 

      //inicializamos
      auxConMov = 0;
      auxSinMov = 0;
    }

    // console.log("% MOVIMIENTO");
    // console.log(this.data);


    if(flagHistorico){
      this.numDia = this.dataHistorico.length/24;
  
      let dataHistoricoAux = [];
      dataHistoricoAux = this.dataHistorico;
      this.dataHistorico = [];
  
      for(let i=0; i < 24; i++){
        this.dataHistorico [i] = dataHistoricoAux[i]
        for(let j=1; j < this.numDia; j++){ // El primer día ya lo hemos metido
          this.dataHistorico[i] = this.dataHistorico[i] + dataHistoricoAux[24*j+i]
        }
        this.dataHistorico[i] =  Math.round(this.dataHistorico[i]/this.numDia);
      }
    }
   
    if(!flagHistorico){
      let tiempoaux: any = 0;
      this.labelsGrafica = [];
      for (let i = 0; i < labelTimestamp.length; i++) {
      if(labelTimestamp[i] != undefined){
        //console.log(moment(this.dataGrafica.data.timestamp[i]).format("HH:mm"));
        tiempoaux = moment(labelTimestamp[i]).format("HH:00");
        if (tiempoaux == "00:00"){
          this.labelsGrafica.push(moment(labelTimestamp[i]).format("DD/MM/YYYY"));
        }else{
          this.labelsGrafica.push(moment(labelTimestamp[i]).format("HH:00"));
        }
      }
      }
    } 

    if (this.chart){
      this.chart.clear();
      this.chart.destroy();
    }
    this.configGrafica();
  }

  // ------------------------------------------ CAMPIOS DE OCUPACIÓN -------------------------------------------------------  
  numCambiosOcupa(){
    // Calculamos el porcentaje de movimiento durante el día de hora a hora
    //Limpiamos los valores
    this.data = [];
    this.labels = [];

    let horaIni;
    let horaFin;
    
    horaIni = datePipe.transform(this.dataGrafica.data.timestamp[0], 'HH:mm dd/MM/YYY');
    horaFin = datePipe.transform(this.dataGrafica.data.timestamp[this.dataGrafica.data.timestamp.length-1], 'HH:mm dd/MM/YYY');

    // console.log(horaIni);
    // console.log(horaFin);

    // console.log(this.dataGrafica.data);
    this.asyncMethodConvertTimeCambiosOcupa();

  }

  async asyncMethodConvertTimeCambiosOcupa() {
    let timestampAux: number [] = [];
    let dataAux: number[] = [];
    let labelsAux: any[] = []
    
    //primero  eliminamos los que tengan un cambio inferior a 5 min.(300000 ms) 

    dataAux.push(this.dataGrafica.data.data[0]);
    timestampAux.push(this.dataGrafica.data.timestamp[0]);

    for (let i = 1; i < this.dataGrafica.data.data.length -1; i++) {
      if(this.dataGrafica.data.data[i] != undefined){
        if((this.dataGrafica.data.timestamp[i] - this.dataGrafica.data.timestamp[i-1]) > 300000){
          dataAux.push(this.dataGrafica.data.data[i]);
          timestampAux.push(this.dataGrafica.data.timestamp[i]);
        }
      }
    }

    for (let i = 0; i < timestampAux.length; i++) {
      if(timestampAux[i] != undefined){
        labelsAux.push(moment(timestampAux[i]).format("HH:mm:DD:MM:YYYY"));
      }
    }


    if(this.DEBUG){   
      console.log("NEW DATA: ");
      console.log(dataAux);
      console.log("NEW TIMESTAMP: ");
      console.log(timestampAux);
      console.log("NEW labels: ");
      console.log(labelsAux);
    }

    let timeAux: number;
    let labelTimestamp: number[] = [];

    // Hacemos el eje X correspondiente a las horas
    labelTimestamp[0] = this.timeIni;
    timeAux = this.timeIni;

    // console.log("TimeIni: " + this.timeIni);
    // console.log("TimeFin: " + this.timeFin);
    // console.log("TIMEAUX:" + timeAux);

    while (timeAux < this.timeFin){
      labelTimestamp.push(timeAux + horaTimestamp);
      timeAux = timeAux + horaTimestamp;
    }

    for (let i = 0; i < labelTimestamp.length; i++) {
      if(labelTimestamp[i] != undefined){
          this.labels.push(moment(labelTimestamp[i]).format("HH:00:DD:MM:YYYY"));
      }
    }

    // console.log(this.labels);

    //limpiamos data donde meteremos el %
    this.data = [];

    // console.log(dataAux[0]);

    let auxCambios= 0;

    for(let i=0; i < this.labels.length; i++){ //for(let i=1; i < this.labels.length-1; i++){

      for(let j=1;j < labelsAux.length-1; j++){

        if ((this.labels[i].split(":")[0] == labelsAux[j].split(":")[0]) && (this.labels[i].split(":")[2] == labelsAux[j].split(":")[2]) ){
          // Estamos en la misma hora y guardamos los cambios en la ocupacion
          //Miramos si j=0
          if (dataAux[j-1] != dataAux[j]){
            //Hay un cambio y lo contamos
            auxCambios = auxCambios + 1;
          }

        }
      }

      if(this.DEBUG){  
        console.log(i + " - "+ this.labels[i] + " - NÚMERO DE CAMBIOS: " +auxCambios);
      }

      this.data[i] = auxCambios;

      //inicializamos
      auxCambios = 0;
    }

    // console.log("% MOVIMIENTO");
    // console.log(this.data);


    let tiempoaux: any = 0;
    this.labels = [];
    for (let i = 0; i < labelTimestamp.length; i++) {
    if(labelTimestamp[i] != undefined){
      //console.log(moment(this.dataGrafica.data.timestamp[i]).format("HH:mm"));
      tiempoaux = moment(labelTimestamp[i]).format("HH:00");
      if (tiempoaux == "00:00"){
        this.labels.push(moment(labelTimestamp[i]).format("DD/MM/YYYY"));
      }else{
        this.labels.push(moment(labelTimestamp[i]).format("HH:00"));
      }
    }
    }

    if (this.chart){
      this.chart.clear();
      this.chart.destroy();
    }
    this.configGrafica();
  }

  // ------------------------------------------ PORCENTAJE DE INACTIVIVIDAD EN REPOSO -----------------------------------------
  porInactividad(){
  // Calculamos el porcentaje de ocupación durante el día de hora a hora
  //Limpiamos los valores
  this.data = [];
  this.dataHistorico = [];
  this.labels = [];
  this.labelsHistorico = [];
  this.labelsGrafica = [];

  // let horaIni;
  // let horaFin;
  
  // horaIni = datePipe.transform(this.dataGraficaInactividad.data.timestamp[0], 'HH:mm dd/MM/YYY');
  // horaFin = datePipe.transform(this.dataGraficaInactividad.data.timestamp[this.dataGraficaInactividad.data.timestamp.length-1], 'HH:mm dd/MM/YYY');



  this.asyncMethodConvertTimeInactividad();


  }

  async asyncMethodConvertTimeInactividad(){
  let timestampAux: number [] = [];
  let ocupAux: number[] = [];
  let pirAux: number[] = [];
  let labelsAux: any[] = []
  
  //primero  eliminamos los que tengan un cambio inferior a 10 seg.(10000 ms) 

  ocupAux.push(this.dataGraficaInactividad.data.ocup[0]);
  pirAux.push(this.dataGraficaInactividad.data.pir[0]);
  timestampAux.push(this.dataGraficaInactividad.data.timestamp[0]);

  // ocupación
  for (let i = 1; i < this.dataGraficaInactividad.data.timestamp.length ; i++) {
    if(this.dataGraficaInactividad.data.ocup[i] != undefined && this.dataGraficaInactividad.data.pir[i] != undefined){
      if((this.dataGraficaInactividad.data.timestamp[i] - this.dataGraficaInactividad.data.timestamp[i-1]) > 10000){
        ocupAux.push(this.dataGraficaInactividad.data.ocup[i]);
        pirAux.push(this.dataGraficaInactividad.data.pir[i]);
        timestampAux.push(this.dataGraficaInactividad.data.timestamp[i]);
      }
    }
  }


  for (let i = 0; i < timestampAux.length; i++) {
    if(timestampAux[i] != undefined){
      labelsAux.push(moment(timestampAux[i]).format("HH:mm:DD:MM:YYYY"));
    }
  }

if(this.DEBUG){    
  console.log("NEW DATA OCUP: ");
  console.log(ocupAux);
  console.log("NEW DATA PIR: ");
  console.log(pirAux);
  console.log("NEW TIMESTAMP: ");
  console.log(timestampAux);
  console.log("NEW labels: ");
  console.log(labelsAux); 
}



  let timeAux: number;
  let labelTimestamp: number[] = [];

  // Hacemos el eje X correspondiente a las horas
  labelTimestamp[0] = this.timeIni;
  timeAux = this.timeIni;

  while (timeAux < this.timeFin){
    labelTimestamp.push(timeAux + horaTimestamp);
    timeAux = timeAux + horaTimestamp;
  }


    this.labels = [];
    for (let i = 0; i < labelTimestamp.length-1; i++) {
      if(labelTimestamp[i] != undefined){
          this.labels.push(moment(labelTimestamp[i]).format("HH:00:DD:MM:YYYY"));
      }
  }

  // console.log(this.labels);

  this.data = [];


  let auxReposo = 0;;
  let auxMovimiento = 0;
  console.log(this.labels.length)
  console.log(labelsAux.length)
  
  for(let i=0; i < this.labels.length-1; i++){ //for(let i=1; i < this.labels.length-1; i++){
    for(let j=0;j < labelsAux.length; j++){ //for(let j=0;j < labelsAux.length-1; j++){
      if ((this.labels[i].split(":")[0] == labelsAux[j].split(":")[0]) && (this.labels[i].split(":")[2] == labelsAux[j].split(":")[2]) ){
        // Estamos en la misma hora y guardamos los min que esta ocupado de 1 a 0
        //Miramos si j=0
        if(j==0){
            if(ocupAux[j] == 1 && pirAux[j] == 1){
              // REPOSO
              auxMovimiento = auxMovimiento + (60 - Number(labelsAux[j].split(":")[1]));
            }else if (ocupAux[j] == 1 && pirAux[j] == 0){
              // REPOSO
              auxReposo = auxReposo + (60 - Number(labelsAux[j].split(":")[1]));
            }
        }else{

           // Misma hora
          if(labelsAux[j-1].split(":")[0] == labelsAux[j].split(":")[0]){
            if ( (ocupAux[j] == 1 && pirAux[j] == 1) && (ocupAux[j-1] == 1 && pirAux[j-1] == 1) ){
              // MOVIMIENTO
              auxMovimiento = auxMovimiento + (Number(labelsAux[j].split(":")[1]) - Number(labelsAux[j-1].split(":")[1]));

            }else if ( (ocupAux[j] == 1 && pirAux[j] == 1) && (ocupAux[j-1] == 1 && pirAux[j-1] == 0) ){
              //MOVIMIENTO
              auxMovimiento = auxMovimiento + (Number(labelsAux[j].split(":")[1]) - Number(labelsAux[j-1].split(":")[1]));

            }else if ( (ocupAux[j] == 1 && pirAux[j] == 0) && (ocupAux[j-1] == 0 && pirAux[j-1] == 0) ){
              //OCUPADO
              auxReposo = auxReposo + (Number(labelsAux[j].split(":")[1]) - Number(labelsAux[j-1].split(":")[1]));

            }else if ( (ocupAux[j] == 1 && pirAux[j] == 0) && (ocupAux[j-1] == 1 && pirAux[j-1] == 1) ){
              //OCUPADO
              auxReposo = auxReposo + (Number(labelsAux[j].split(":")[1]) - Number(labelsAux[j-1].split(":")[1]));
            }
          }
          if((Number(labelsAux[j].split(":")[0]) < Number(labelsAux[j+1].split(":")[0])) && (Number(labelsAux[j].split(":")[2]) == Number(labelsAux[j+1].split(":")[2]))){ 
            // último dato de la hora del mismo día
                if(ocupAux[j] == 1 && pirAux[j] == 1){
                  //MOVIMIENTO
                  auxMovimiento = auxMovimiento + (60 - Number(labelsAux[j].split(":")[1]));
                }else if (ocupAux[j] == 1 && pirAux[j] == 0){
                  //libre
                  auxReposo = auxReposo + (60 - Number(labelsAux[j].split(":")[1]));
                
                }
  
            }else if((Number(labelsAux[j].split(":")[0]) > Number(labelsAux[j+1].split(":")[0])) && (Number(labelsAux[j].split(":")[2]) < Number(labelsAux[j+1].split(":")[2]))){ 
            // último dato de la hora de finales del día 
              if(ocupAux[j] == 1 && pirAux[j] == 1){
                //libre
                auxMovimiento = auxMovimiento + (60 - Number(labelsAux[j].split(":")[1]));
              }else if (ocupAux[j] == 1 && pirAux[j] == 0){
                //libre
                auxReposo = auxReposo + (60 - Number(labelsAux[j].split(":")[1]));
              
              }
            }
          // primer dato de la hora
          // if ((Number(labelsAux[j-1].split(":")[0]) < Number(labelsAux[j].split(":")[0]))){ 
          //   if (dataAux[j-1] == 0 && dataAux[j] == 0){
          //     //LIBRE
          //     auxLib = auxLib + Number(labelsAux[j].split(":")[1]);
          //   }else if (dataAux[j-1] == 0 && dataAux[j] == 1){
          //     //LIBRE
          //     auxLib = auxLib + Number(labelsAux[j].split(":")[1]);

          //   }else if (dataAux[j-1] == 1 && dataAux[j] == 1){
          //     //OCUPADO
          //     auxOcup = auxOcup + Number(labelsAux[j].split(":")[1]);

          //   }else if (dataAux[j-1] == 1 && dataAux[j] == 0){
          //     //OCUPADO
          //     auxOcup = auxOcup + Number(labelsAux[j].split(":")[1]);

          //   }
          // }
        }
      }

    }

    if(this.DEBUG){  
      console.log(i + " - "+ this.labels[i] + " - REPOSO: " + auxReposo +" m - MOVIMIENTO: " + auxMovimiento );
    }
    
    // Pasamos los datos a %
    auxReposo = (auxReposo * 100)/60

    this.data[i] = Math.round(auxReposo);


    //inicializamos
    auxReposo = 0;
    auxMovimiento = 0;
    // console.log("HOLAA");
  }
  
  if(this.DEBUG){
    console.log("% INACTIVIDAD");
    console.log(this.data);
  }



    let tiempoaux: any = 0;
    this.labelsGrafica = [];
    for (let i = 0; i < labelTimestamp.length; i++) {
    if(labelTimestamp[i] != undefined){
      //console.log(moment(this.dataGrafica.data.timestamp[i]).format("HH:mm"));
      tiempoaux = moment(labelTimestamp[i]).format("HH:00");
      if (tiempoaux == "00:00"){
        this.labelsGrafica.push(moment(labelTimestamp[i]).format("DD/MM/YYYY"));
      }else{
        this.labelsGrafica.push(moment(labelTimestamp[i]).format("HH:00"));
      }
    }
    }
  

  if (this.chart){
    this.chart.clear();
    this.chart.destroy();
  }
  this.configGrafica();
  }

  // ------------------------------------------ USO DEL FRIGORÍFICO -----------------------------------------

  usoFridge(){

  //Limpiamos los valores
  this.data = [];
  this.dataHistorico = [];
  this.labels = [];
  this.labelsHistorico = [];
  this.labelsGrafica = [];
  // let horaIni;
  // let horaFin;
  
  // horaIni = datePipe.transform(this.dataGrafica.data.timestamp[0], 'HH:mm dd/MM/YYY');
  // horaFin = datePipe.transform(this.dataGrafica.data.timestamp[this.dataGrafica.data.timestamp.length-1], 'HH:mm dd/MM/YYY');

  this.asyncMethodConvertTimeUsoFridge(this.dataGrafica, false);

  if(this.flagGraficaHistorico){
    this.asyncMethodConvertTimeUsoFridge(this.dataGraficaHistorico, true);
  }

  }

  asyncMethodConvertTimeUsoFridge(dataGraficaLocal, flagHistorico: boolean){
  this.timeIni = dataGraficaLocal.timeIni; 
  this.timeFin = dataGraficaLocal.timeFin;

  let timestampAux: number [] = [];
  let dataAux: number[] = [];
  let labelsAux: any[] = [];
  
  //primero  eliminamos los que tengan un cambio inferior a 5 min.(300000 ms) 
  dataAux.push(dataGraficaLocal.data.data[0]);
  timestampAux.push(dataGraficaLocal.data.timestamp[0]);

  for (let i = 1; i < dataGraficaLocal.data.data.length -1; i++) {
    if(dataGraficaLocal.data.data[i] != undefined){
      // if((this.dataGrafica.data.timestamp[i] - this.dataGrafica.data.timestamp[i-1]) > 300000){
        dataAux.push(dataGraficaLocal.data.data[i]);
        timestampAux.push(dataGraficaLocal.data.timestamp[i]);
      // }
    }
  }

  for (let i = 0; i < timestampAux.length; i++) {
    if(timestampAux[i] != undefined){
      labelsAux.push(moment(timestampAux[i]).format("HH:mm:DD:MM:YYYY"));
    }
  }


  // if(this.DEBUG){   
  //   console.log("NEW DATA: ");
  //   console.log(dataAux);
  //   console.log("NEW TIMESTAMP: ");
  //   console.log(timestampAux);
  //   console.log("NEW labels: ");
  //   console.log(labelsAux);
  // }

  let timeAux: number;
  let labelTimestamp: number[] = [];

  // Hacemos el eje X correspondiente a las horas
  labelTimestamp[0] = this.timeIni;
  timeAux = this.timeIni;

  while (timeAux < this.timeFin){
    labelTimestamp.push(timeAux + horaTimestamp);
    timeAux = timeAux + horaTimestamp;
  }

  if(!flagHistorico){
    // console.log("1 DIA");
    // Guardamos el eje X que es el de 1 día
    this.labels = [];
    for (let i = 0; i < labelTimestamp.length-1; i++) {
      if(labelTimestamp[i] != undefined){
          this.labelsGrafica.push(moment(labelTimestamp[i]).format("HH:00:DD:MM:YYYY"));
          this.labels.push(moment(labelTimestamp[i]).format("HH:00:DD:MM:YYYY"));
      }
    }
    // console.log("LABELS GRAFICA:");
    // console.log(this.labelsGrafica);
  }else{
    // console.log("HISTORICO");
    this.labels = [];
    for (let i = 0; i < labelTimestamp.length-1; i++) {
      if(labelTimestamp[i] != undefined){
          this.labels.push(moment(labelTimestamp[i]).format("HH:00:DD:MM:YYYY"));
      }
    }
  }

  //limpiamos data o dataHistorico donde meteremos el %
  if(flagHistorico){
    this.dataHistorico = [];
  }else{
    this.data = [];
  }
  

  let auxCambios= 0;

  for(let i=0; i < this.labels.length; i++){ //for(let i=1; i < this.labels.length-1; i++){
    for(let j=1; j < labelsAux.length-1; j++){ //for(let j=1; j < labelsAux.length-1; j++){
      if ((this.labels[i].split(":")[0] == labelsAux[j].split(":")[0]) && (this.labels[i].split(":")[2] == labelsAux[j].split(":")[2]) ){
        // Estamos en la misma hora y guardamos los cambios en la ocupacion
        //Miramos si j=0
        if (dataAux[j] == 1){//if (dataAux[j-1] != dataAux[j]){
          //Hay un cambio y lo contamos
          auxCambios = auxCambios + 1;
          
        }

      }
    }

    if(this.DEBUG){  
      // console.log(i + " - "+ this.labels[i] + " - NÚMERO DE CAMBIOS: " + auxCambios);
    }

    if(flagHistorico){
      this.dataHistorico[i] = auxCambios;
    }else{
      this.data[i] = auxCambios;
    }
    
    //inicializamos
    auxCambios = 0;
  }

  if(flagHistorico){
    this.numDia = this.dataHistorico.length/24;

    let dataHistoricoAux = [];
    dataHistoricoAux = this.dataHistorico;
    this.dataHistorico = [];

    for(let i=0; i < 24; i++){
      this.dataHistorico [i] = dataHistoricoAux[i]
      for(let j=1; j < this.numDia; j++){ // El primer día ya lo hemos metido
        this.dataHistorico[i] = this.dataHistorico[i] + dataHistoricoAux[24*j+i]
      }
      this.dataHistorico[i] = this.dataHistorico[i]/this.numDia;
    }


  }
 
  if(!flagHistorico){
    let tiempoaux: any = 0;
    this.labelsGrafica = [];
    for (let i = 0; i < labelTimestamp.length; i++) {
    if(labelTimestamp[i] != undefined){
      //console.log(moment(this.dataGrafica.data.timestamp[i]).format("HH:mm"));
      tiempoaux = moment(labelTimestamp[i]).format("HH:00");
      if (tiempoaux == "00:00"){
        this.labelsGrafica.push(moment(labelTimestamp[i]).format("DD/MM/YYYY"));
      }else{
        this.labelsGrafica.push(moment(labelTimestamp[i]).format("HH:00"));
      }
    }
    }
  }   

  if (this.chart){
    this.chart.clear();
    this.chart.destroy();
  }
  this.configGrafica();
  }


// ------------------------------------------ PORCENTAJE DE MOVIMIENTO EN LA COCINA -----------------------------------------
  porMovimientoCocina(){
  // Calculamos el porcentaje de movimiento durante el día de hora a hora
  //Limpiamos los valores
  this.data = [];
  this.dataHistorico = [];
  this.labels = [];
  this.labelsHistorico = [];
  this.labelsGrafica = [];

  this.asyncMethodConvertTimePorMovimientoCocina(this.dataGrafica, false);

  if(this.flagGraficaHistorico){
    this.asyncMethodConvertTimePorMovimientoCocina(this.dataGraficaHistorico, true);
  }

  }

  async asyncMethodConvertTimePorMovimientoCocina(dataGraficaLocal, flagHistorico: boolean) {
  this.timeIni = dataGraficaLocal.timeIni; 
  this.timeFin = dataGraficaLocal.timeFin;

  let timestampAux: number [] = [];
  let dataAux: number[] = [];
  let labelsAux: any[] = []
  
  //primero  eliminamos los que tengan un cambio inferior a 1 min.(60000 ms) 

  dataAux.push(dataGraficaLocal.data.data[0]);
  timestampAux.push(dataGraficaLocal.data.timestamp[0]);

  for (let i = 1; i < dataGraficaLocal.data.data.length -1; i++) {
    if(dataGraficaLocal.data.data[i] != undefined){
      if((dataGraficaLocal.data.timestamp[i] - dataGraficaLocal.data.timestamp[i-1]) > 60000){
        dataAux.push(dataGraficaLocal.data.data[i]);
        timestampAux.push(dataGraficaLocal.data.timestamp[i]);
      }
    }
  }

  for (let i = 0; i < timestampAux.length; i++) {
    if(timestampAux[i] != undefined){
      labelsAux.push(moment(timestampAux[i]).format("HH:mm:DD:MM:YYYY"));
    }
  }


  // if(this.DEBUG){   
  //   console.log("NEW DATA: ");
  //   console.log(dataAux);
  //   console.log("NEW TIMESTAMP: ");
  //   console.log(timestampAux);
  //   console.log("NEW labels: ");
  //   console.log(labelsAux);
  // }

  let timeAux: number;
  let labelTimestamp: number[] = [];

  // Hacemos el eje X correspondiente a las horas
  labelTimestamp[0] = this.timeIni;
  timeAux = this.timeIni;

  while (timeAux < this.timeFin){
    labelTimestamp.push(timeAux + horaTimestamp);
    timeAux = timeAux + horaTimestamp;
  }

  if(!flagHistorico){
    console.log("1 DIA");
    // Guardamos el eje X que es el de 1 día
    this.labels = [];
    for (let i = 0; i < labelTimestamp.length-1; i++) {
      if(labelTimestamp[i] != undefined){
          this.labelsGrafica.push(moment(labelTimestamp[i]).format("HH:00:DD:MM:YYYY"));
          this.labels.push(moment(labelTimestamp[i]).format("HH:00:DD:MM:YYYY"));
      }
    }
    // console.log("LABELS GRAFICA:");
    // console.log(this.labelsGrafica);
  }else{
    console.log("HISTORICO");
    
    this.labels = [];
    for (let i = 0; i < labelTimestamp.length-1; i++) {
      if(labelTimestamp[i] != undefined){
          this.labels.push(moment(labelTimestamp[i]).format("HH:00:DD:MM:YYYY"));
      }
    }
    // console.log("LABELS HISTORICO:");
    // console.log(this.labels);
  }

  // console.log(this.labels);

  //limpiamos data o dataHistorico donde meteremos el %
  if(flagHistorico){
    this.dataHistorico = [];
  }else{
    this.data = [];
  }

  // console.log(dataAux[0]);

  let auxConMov= 0;;
  let auxSinMov = 0;

  for(let i=0; i < this.labels.length; i++){ //for(let i=1; i < this.labels.length-1; i++){

    for(let j=1;j < labelsAux.length-1; j++){ //for(let i=1; i < this.labels.length-1; i++){

      if ((this.labels[i].split(":")[0] == labelsAux[j].split(":")[0]) && (this.labels[i].split(":")[2] == labelsAux[j].split(":")[2]) ){
        // Estamos en la misma hora y guardamos los min que esta en movimiento de 1 a 0
        //Miramos si j=0
        if(j==0){
            if(dataAux[j] == 0){
              // SINMovimiento
              auxSinMov = auxSinMov + (60 - Number(labelsAux[j].split(":")[1]));
            }else if (dataAux[j] == 1){
              // SINMovimiento
              auxConMov = auxConMov + (60 - Number(labelsAux[j].split(":")[1]));
              this.data[i] = auxConMov;
            }
        }else{

           // Misma hora
          if(labelsAux[j-1].split(":")[0] == labelsAux[j].split(":")[0]){
            if (dataAux[j-1] == 0 && dataAux[j] == 0){
              //SINMovimiento
              auxSinMov = auxSinMov + (Number(labelsAux[j].split(":")[1]) - Number(labelsAux[j-1].split(":")[1]));
            }else if (dataAux[j-1] == 0 && dataAux[j] == 1){
              //SINMovimiento
              auxSinMov = auxSinMov + (Number(labelsAux[j].split(":")[1]) - Number(labelsAux[j-1].split(":")[1]));
            }else if (dataAux[j-1] == 1 && dataAux[j] == 1){
              //CONMovimiento
              auxConMov = auxConMov + (Number(labelsAux[j].split(":")[1]) - Number(labelsAux[j-1].split(":")[1]));
            }else if (dataAux[j-1] == 1 && dataAux[j] == 0){
              //CONMovimiento
              auxConMov = auxConMov + (Number(labelsAux[j].split(":")[1]) - Number(labelsAux[j-1].split(":")[1]));
            }
          }
          // último dato de la hora
          if((Number(labelsAux[j].split(":")[0]) < Number(labelsAux[j+1].split(":")[0]))){ 

              if(dataAux[j] == 0){
                //SINMovimiento
                auxSinMov = auxSinMov + (60 - Number(labelsAux[j].split(":")[1]));
              }else if (dataAux[j] == 1){
                //CONMovimiento
                auxConMov = auxConMov + (60 - Number(labelsAux[j].split(":")[1]));
              
              }

          }
          // primer dato de la hora
          if ((Number(labelsAux[j-1].split(":")[0]) < Number(labelsAux[j].split(":")[0]))){ 
            if (dataAux[j-1] == 0 && dataAux[j] == 0){
              //SINMovimiento
              auxSinMov = auxSinMov + Number(labelsAux[j].split(":")[1]);
            }else if (dataAux[j-1] == 0 && dataAux[j] == 1){
              //SINMovimiento
              auxSinMov = auxSinMov + Number(labelsAux[j].split(":")[1]);

            }else if (dataAux[j-1] == 1 && dataAux[j] == 1){
              //CONMovimiento
              auxConMov = auxConMov + Number(labelsAux[j].split(":")[1]);

            }else if (dataAux[j-1] == 1 && dataAux[j] == 0){
              //CONMovimiento
              auxConMov = auxConMov + Number(labelsAux[j].split(":")[1]);

            }
          }
        }
      }
    }

    if(this.DEBUG){  
      // console.log(i + " - "+ this.labels[i] + " - SIN MOVIMIENTO: " +auxSinMov +" m - EN MOVIMIENTO: " + auxConMov );
    }
    // Pasamos los datos a %
    auxConMov = (auxConMov * 100)/60

    if(flagHistorico){
      this.dataHistorico[i] = Math.round(auxConMov);
      console.log(i + " - "+ this.labels[i] + "EN MOVIMIENTO : " + auxConMov + "%");
    }else{
      this.data[i] = Math.round(auxConMov);
      console.log(i + " - "+ this.labels[i] + "EN MOVIMIENTO : " + auxConMov + "%");
    }    
    

    //inicializamos
    auxConMov = 0;
    auxSinMov = 0;
  }

  // console.log("% MOVIMIENTO");
  // console.log(this.data);

  if(flagHistorico){
    this.numDia = this.dataHistorico.length/24;

    let dataHistoricoAux = [];
    dataHistoricoAux = this.dataHistorico;
    this.dataHistorico = [];

    for(let i=0; i < 24; i++){
      this.dataHistorico [i] = dataHistoricoAux[i]
      for(let j=1; j < this.numDia; j++){ // El primer día ya lo hemos metido
        this.dataHistorico[i] = this.dataHistorico[i] + dataHistoricoAux[24*j+i]
      }
      this.dataHistorico[i] =  Math.round(this.dataHistorico[i]/this.numDia);
    }
  }
 
  if(!flagHistorico){
    let tiempoaux: any = 0;
    this.labelsGrafica = [];
    for (let i = 0; i < labelTimestamp.length; i++) {
    if(labelTimestamp[i] != undefined){
      //console.log(moment(this.dataGrafica.data.timestamp[i]).format("HH:mm"));
      tiempoaux = moment(labelTimestamp[i]).format("HH:00");
      if (tiempoaux == "00:00"){
        this.labelsGrafica.push(moment(labelTimestamp[i]).format("DD/MM/YYYY"));
      }else{
        this.labelsGrafica.push(moment(labelTimestamp[i]).format("HH:00"));
      }
    }
    }
  }  

  if (this.chart){
    this.chart.clear();
    this.chart.destroy();
  }
  this.configGrafica();
  }
}